import { useQueryClient } from '@tanstack/react-query';

import type { RfidCardUpdateType } from '@/api/schema';
import { RfidCardsList, type RfidCardType } from '@/api/schema';
import { useApiMutation } from '@/hooks/useApiMutation';
import { useApiQuery } from '@/hooks/useApiQuery';
import { axiosInstance } from '@/lib/api/axios';

// GET: /cards
const fetchRfidCards = async (): Promise<{ cards: RfidCardType[] }> => {
    const { data } = await axiosInstance.get<{ cards: RfidCardType[] }>('/cards');

    return data;
};

export const useRfidCards = () =>
    useApiQuery({
        queryKey: ['rfid-cards'],
        fetcher: fetchRfidCards,
        validator: RfidCardsList,
    });

// PUT: /cards/:serial
const updateCard = async ({ serial, ...data }: RfidCardUpdateType): Promise<void> => {
    const { data: response } = await axiosInstance.put(`/cards/${serial}`, data);
    return response;
};

export const useUpdateCard = () => {
    const queryClient = useQueryClient();

    return useApiMutation({
        mutationFn: updateCard,
        options: {
            onSuccess: () => {
                queryClient.invalidateQueries({ queryKey: ['rfid-cards'] });
            },
        },
    });
};
